// extracted by css-extract-rspack-plugin
export default {"panel":"izL6r","body":"VwusR","frame":"_QJFI"};